import React, { useEffect } from "react";
import styles from "./return-service.scss";
import StaticPage from "../static-page/static-page";
import { useParamas } from '@tw/shared-ui-components/lib/utils/helper';

export default function ReturnService() {
  const { params } = useParamas();
  useEffect(() => {
    try {
      if (typeof window !== undefined && params) {
        const { anchor } = params;
        // 使用setTimeout确保富文本内容已渲染完成
        setTimeout(() => {
          const targetElement = document.getElementById(anchor);
          // 检查目标元素是否存在
          if (targetElement) {
            // 计算目标位置（考虑导航栏高度）
            const targetPosition = targetElement.getBoundingClientRect().top +
              window.pageYOffset;
            // 平滑滚动到目标位置
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          } else {
            console.log(`Element with id "${anchor}" not found`);
          }
        }, 500);
      }
    } catch (error) {
      console.log(error);
    }
  }, [params]);
  return (
    <StaticPage>
      <div className={styles["order-con container"]}>
        &nbsp;
        <div className={styles["color-lump"]}>
          <div className={styles["color-text"]}>滿意保證</div>
        </div>
        <p></p>
        <div className={styles["color-lump1"]}>
          <div className={styles["paragraph-text"]}>
            凡經由安麗官方網站或透過安麗直銷商/會員合法管道購買之安麗全產品，您都能在產品未拆封的情況下享有14天猶豫期；針對特定安麗產品，您另可在產品使用一段合理時間後，決定是否滿意、是否繼續保留使用。安麗提供更友好且完善的滿意保證制度，詳細分類如下：
          </div>
          <div style={{ paddingTop: '10px' }}>直銷商/會員</div>
          <p></p>
          <table>
            <tbody>
              <tr>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                    width: "80px",
                  }}
                >
                  類別
                </th>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                  }}
                >
                  適用購買品項
                </th>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                  }}
                >
                  條件說明
                </th>
              </tr>
              <tr>
                <td>
                  2年
                  <br />
                  滿意保證
                </td>
                <td>
                  <ul>
                    <li>
                      除「90天滿意保證產品」和「僅有14天猶豫期產品」以外的其他安麗產品
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算2年內</li>
                    <li>產品已拆封但未使用完畢</li>
                    <li>
                      如為內容物獨立分裝之產品，使用後須仍至少有一份以上之餘量（即一份以上未拆封之獨立小包裝或小瓶裝）
                    </li>
                    <li>產品仍在有效期限內</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  90天
                  <br />
                  滿意保證
                </td>
                <td>
                  <ul>
                    <li>
                      家用科技耐久性產品（包含空氣清淨機、淨水器、鍋具、電動牙刷、美肌儀…等）及其他安麗購物網站註明90天滿意保證之產品
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算90天內</li>
                    <li>產品已拆封試用</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  14天
                  <br />
                  猶豫期
                </td>
                <td>
                  安麗全產品，但以下產品僅享有14天猶豫期，無90天或2年滿意保證之適用：
                  <ul>
                    <li>耗材</li>
                    <li>輔銷品</li>
                    <li>異業結盟產品（例如：特級冷壓橄欖油及R&J系列）</li>
                    <li>
                      積點兌換、積點加價購或贈品（請注意，
                      積點折抵續約並非產品，故不適用14天猶豫期，一經折抵即無法回復。）
                    </li>
                    <li>其他安麗購物網站註明僅享14天猶豫期之產品</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算14天內</li>
                    <li>未拆封之產品</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ paddingTop: '15px' }}>安麗之友/訪客</div>
          <p></p>
          <table>
            <tbody>
              <tr>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                    width: "80px",
                  }}
                >
                  類別
                </th>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                  }}
                >
                  適用購買品項
                </th>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#fff2cc",
                  }}
                >
                  條件說明
                </th>
              </tr>
              <tr>
                <td>
                  30天
                  <br />
                  滿意保證
                </td>
                <td>
                  <ul>
                    <li>
                      除「90天滿意保證產品」和「14天猶豫期產品」以外的其他安麗產品
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算30天內</li>
                    <li>產品已拆封但未使用完畢</li>
                    <li>如為內容物獨立分裝之產品，使用後須仍至少有一份以上之餘量（即一份以上未拆封之獨立小包裝或小瓶裝）</li>
                    <li>產品仍在有效期限內</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  90天
                  <br />
                  滿意保證
                </td>
                <td>
                  <ul>
                    <li>
                      家用科技耐久性產品（包含空氣清淨機、淨水器、鍋具、電動牙刷、美肌儀…等）及其他安麗購物網站註明90天滿意保證之產品
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算90天內</li>
                    <li>產品已拆封試用</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  14天
                  <br />
                  猶豫期
                </td>
                <td>
                  安麗全產品，但以下產品僅享有14天猶豫期，無30天及90天滿意保證之適用：
                  <ul>
                    <li>耗材</li>
                    <li>輔銷品</li>
                    <li>異業結盟產品（例如：特級冷壓橄欖油及R&J系列）</li>
                    <li>積點兌換、積點加價購或贈品（請注意，積點折抵續約並非產品，故不適用14天猶豫期，一經折抵即無法回復。）</li>
                    <li>其他安麗購物網站註明僅享14天猶豫期之產品</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>發票日起算14天內</li>
                    <li>未拆封之產品</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>

          <div className={styles["paragraph-text"]}>
            <div style={{ marginBottom: '10px' }}>※安麗之友-發票日為2025年03月12日前(含)之訂單，滿意保證維持原直銷商/會員之權益。</div>
            針對上述滿意保證制度，安麗提供以下三種選擇：
            <ol>
              <li>免費更換同項產品。</li>
              <li>開立現金代用券換購安麗其他產品（安麗之友及訪客不適用）。</li>
              <li>退還產品貨款（實際給付金額）及/或使用之積點。</li>
            </ol>
            如因意外事件、人為修改、蓄意或未依據產品說明使用而對產品的外觀或功能造成毀損或其他影響者，恕皆無法享有上述三種滿意保證。
            <p></p>
            注意：
            <ol>
              <li>如欲採取退換貨服務，需由原訂貨人進行辦理。</li>
              <li>安麗銷售的產品可於產品頁面內確認該產品的滿意保證內容。</li>
              <li>
                具特殊性質之產品（包括但不限於公益/專案/活動性質之產品），其滿意保證將依活動公告說明為主。
              </li>
              <li>
                退換貨詳細規定請參閱
                <a
                  href="/page?url=how-to-return-detail"
                  style={{ color: "#29698c" }}
                >
                  退換貨辦法
                </a>
                。
              </li>
              <li>滿意保證之詳細規定請以安麗台灣最新公告為準，安麗就此保有說明、變更及補充之權利。</li>
            </ol>
            <br />
          </div>
        </div>
        <div className={styles["color-lump"]}>
          <div className={styles["color-text"]}>免運寄送</div>
        </div>
        <p></p>
        <div className={styles["color-lump1"]}>
          <table>
            <tbody>
              <tr>
                <th
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                  }}
                >
                  標準
                </th>
                <th
                  colspan="2"
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                  }}
                >
                  A
                </th>
                <th
                  colspan="1"
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                  }}
                >
                  B
                </th>
                <th
                  colspan="1"
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                  }}
                >
                  C
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  送貨方式
                  <br />
                  或條件
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  宅配到府
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  超商取貨
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  送貨地址屬於
                  <br />
                  金門/花蓮地區之訂單
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  安麗體驗據點取貨
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                    fontWeight: "bold",
                  }}
                >
                  免運門檻
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                    fontWeight: "bold",
                    minWidth: "50px",
                  }}
                >
                  2,000元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                    fontWeight: "bold",
                    minWidth: "50px",
                  }}
                >
                  2,000元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                    fontWeight: "bold",
                    minWidth: "50px",
                  }}
                >
                  1,000元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#e9ebf5",
                    fontWeight: "bold",
                  }}
                >
                  無門檻
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  未達免運門檻
                  <br />
                  之運費
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  100元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  100元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  100元
                </td>
                <td
                  style={{
                    verticalAlign: "middle !important",
                    textAlign: "center",
                    backgroundColor: "#cfd5ea",
                    fontWeight: "bold",
                  }}
                >
                  免運費
                </td>
              </tr>
            </tbody>
          </table>
          <p></p>
          <br />
        </div>
        <div className={styles["color-lump"]}>
          <div className={styles["color-text"]}>配送服務</div>
        </div>
        <p></p>
        <div className={styles["color-lump1"]}>
          <h5>
            <b>● 宅配到府服務</b>
          </h5>
        </div>
        <div className={`${styles["color-lump1"]} ${styles["paragraph-text"]}`}>
          <ol>
            <li>
              訂單成立且付款完成後將於 2~3 個工作天內配送。
              <br />
              *以上所述配送區域不包含偏遠及離島地區(說明列表<a href="/shopping-faqs/details?l0=blt7ae82f391960a1ab&q=0">詳見附錄</a>)配送約 3~7 個工作天  。
              <br />
              *部分特殊情況、週六、週日、年節假期及促銷特惠期間...等配送將視營運狀況而定，不適用上述出貨規則。
              <br />
              *若遇活動促銷有配送延遲情況，請留意安麗公司網站公告或簡訊通知。
            </li>

            <li>
              宅配貨到付款訂單，到貨前司機將電話聯繫收件人，敬請留意陌生來電，並請備好足夠金額領取商品。
              <br />
            </li>
            <li>
              訂單出貨後，訂單指定之收(取)貨人如未能配合收(取)貨或送貨地址屬不宜配送之場所(如郵政信箱、旅館、軍事設施等)，經安麗公司催領通知仍未能完成收(取)貨時，安麗公司有權取消該筆訂單、取回該商品、處理發票及折讓單等相關法令所要求之單據及退款，並得暫停/終止該筆訂單所適用之長客計畫及相關優惠及權益。
            </li>
          </ol>
        </div>
        <br />
        <div className={styles["color-lump1"]}>
          <h5>
            <b>● 超商取貨服務</b>
          </h5>
        </div>
        <div className={`${styles["color-lump1"]} ${styles["paragraph-text"]}`}>
          <ol>
            <li>若單筆訂單材積或重量超過超商限制，安麗公司將主動拆分貨件，請留意簡訊通知取貨件數。貨件兩件以上之訂單，請攜帶取貨人本人證件前往超商領取。</li>
            <li>超商取貨之訂單，安麗公司出貨後需轉由超商物流處理，訂單成立後約3~7個工作天配達至超商門市。<br /> *若遇活動促銷有配送延遲情況，請留意安麗公司網站公告或簡訊通知。</li>
            <li>貨件送達超商門市後，將以「簡訊」通知取貨人，如未能配合收(取)貨，經安麗公司催領通知仍未能完成收(取)貨時，安麗公司有權取消該筆訂單、取回該商品、處理發票及折讓單等相關法令所要求之單據及退款，並得暫停/終止該筆訂單所適用之長客計畫及相關優惠及權益。</li>
            <li>請在領取包裹的同時，先檢查貨箱狀況，若發現任何外觀破損或有疑慮請不要簽收，直接讓店家退回即可。</li>
            <li>超商取貨當月若有 2 張以上(含)訂單未前往門市領取導致退件，系統將鎖定使用超商取貨功能。</li>
          </ol>
        </div>
        <br id="mattersNeedAttention" />
        <div className={styles["color-lump1"]}>
          <h5>
            <b>● 注意事項</b>
          </h5>
        </div>
        <div className={`${styles["color-lump1"]} ${styles["paragraph-text"]}`}>
          <ol>
            <li>
              貨到付款服務之訂單金額上限如下，若訂單金額超出上限，訂單將不予成立。
              <br />
              <br />
              <table>
                <tbody>
                  <tr>
                    <th
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        backgroundColor: "#fff2cc",
                      }}
                    >
                      貨到付款
                    </th>
                    <th
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        backgroundColor: "#fff2cc",
                      }}
                    >
                      宅配到府
                    </th>
                    <th
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        backgroundColor: "#fff2cc",
                      }}
                    >
                      超商取貨
                    </th>
                    <th
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        backgroundColor: "#fff2cc",
                      }}
                    >
                      中心取貨
                    </th>
                  </tr>
                  <tr>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      金額限制
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      50,000元以下
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      20,000元以下
                    </td>
                    <td
                      style={{
                        verticalAlign: "middle !important",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      不適用
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              同一訂貨人若有多次訂購未取貨記錄，安麗公司有權暫停使用「貨到付款」服務。
            </li>
          </ol>
        </div>
      </div>
      <p></p>
      <script
        async
        type="text/javascript"
        src="https://code.jquery.com/jquery-3.6.0.min.js"
        integrity="sha384-vtXRMe3mGCbOeY7l30aIg8H9p3GdeSe4IFlP6G8JMa7o7lXvnz3GFKzPxzJdPfGK"
        crossorigin="anonymous"
      ></script>
      <script
        async
        src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
        integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n"
        crossorigin="anonymous"
      ></script>
      <script
        async
        src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js"
        integrity="sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6"
        crossorigin="anonymous"
      ></script>
    </StaticPage>
  );
}
